import initialState from './initialState';


export default function createUserReducer(state = initialState.createUserState, action) {

  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/createUserReducer.js